import ListTransferReturns from "../../../../components/@documents/transfer_returns/ListTransferReturns";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function TransferReturnsPage() {

    return (
        <ListTransferReturns 
            routeType={routeTypes.admin}
        />
    )
}